import React, { useEffect, useMemo, useRef, useState } from 'react';
import baseURL from "../component/baseURL";
import showNotification from '../component/Notification';
import { useLocation, useNavigate } from 'react-router-dom';
import PremiumSidebar from './PremiumSidebar';
import stringsoflanguages from '../component/stringsoflanguages';

const PREMIUM_SIDEBAR_PATHS = {
    "Consumer Apps Active": "/premium-home/consumer-apps-active",
    "Consumer App Settings": "/premium-home/consumer-app-settings",
};

export default function ConsumerFilter() {
    const navigate = useNavigate();
    const location = useLocation();
    const [activeItem] = useState(() => location.state?.premiumSidebarActive || 'Consumer Apps Active');
    const [isMobilePageOpen, setIsMobilePageOpen] = useState(false);
    const [userID, setUserID] = useState('');
    const [filterList, setFilterList] = useState([]);
    const [loadData, setLoadData] = useState(false);
    const [search, setSearch] = useState('');
    const [activeMap, setActiveMap] = useState({ 1: false, 2: false, 3: false, 4: false });
    const [isMobile, setIsMobile] = useState(false);
    const [gearMenuOpen, setGearMenuOpen] = useState(false);
    const [gearSpinning, setGearSpinning] = useState(false);
    const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false);
    const [deleteFilterId, setDeleteFilterId] = useState(null);
    const gearMenuRef = useRef(null);

    const filteredCards = useMemo(() => {
        const list = Array.isArray(filterList) ? filterList : [];
        const q = search.trim().toLowerCase();
        if (!q) return list;
        return list.filter((f) => {
            const country = f.country_name ?? f.country ?? '';
            const states = f.states ?? f.state_name ?? f.region_name ?? '';
            const cities = f.cities ?? f.city_name ?? '';
            const text = `${country} ${states} ${cities}`.toLowerCase();
            return text.includes(q);
        });
    }, [search, filterList]);

    const isStatusOn = (value) => String(value ?? '').trim().toUpperCase() === 'Y';

    const handleToggleClick = (item) => {
        const prefId = item?.user_preference_id;
        if (!prefId) {
            showNotification('Error', 'Invalid filter id', 'danger');
            return;
        }
        const apiStatus = item?.status ?? item?.toggle_status ?? item?.filter_status ?? item?.active_status;
        const next = !isStatusOn(apiStatus);
        setActiveMap((prev) => ({ ...prev, [prefId]: next }));
        toggleChangeAPI(prefId, next ? 'Y' : 'N');
    };

    useEffect(() => {
        const checkMobile = () => setIsMobile(window.innerWidth <= 767);
        checkMobile();
        window.addEventListener('resize', checkMobile);
        return () => window.removeEventListener('resize', checkMobile);
    }, []);

    useEffect(() => {
        if (window.innerWidth <= 767) {
            setIsMobilePageOpen(true);
        }
    }, []);

    useEffect(() => {
        document.body.classList.add('premium-page');
        return () => {
            document.body.classList.remove('premium-page');
        };
    }, []);

    useEffect(() => {
        const userid = localStorage.getItem('user_id');
        setUserID(userid || '');
        fetchFilterApi(userid);
        const handleGearClickOutside = (e) => {
            if (gearMenuRef.current && !gearMenuRef.current.contains(e.target)) {
                setGearMenuOpen(false);
            }
        };
        document.addEventListener('mousedown', handleGearClickOutside);
        return () => document.removeEventListener('mousedown', handleGearClickOutside);
    }, []);

    const backToPremiumMembers = () => {
        window.dispatchEvent(
            new CustomEvent("premiumMembersView", {
                detail: { isViewing: true },
            })
        );
        navigate("/premium-home/premium-members");
    };

    const navigateBackFromConsumerFilter = () => {
        const st = location.state;
        if (st?.consumer_details != null || st?.consumer_id != null) {
            navigate("/premium-home/consumer-list", {
                state: {
                    consumer_details: st.consumer_details,
                    consumer_id: st.consumer_id,
                    consumer_name: st.consumer_name,
                    premiumSidebarActive: st.premiumSidebarActive || "Consumer Apps Active",
                },
            });
            return;
        }
        backToPremiumMembers();
    };

    const handlePremiumSidebarNavigate = (item) => {
        window.dispatchEvent(
            new CustomEvent("premiumMembersView", {
                detail: { isViewing: item === "Premium Members" },
            })
        );
        const path = PREMIUM_SIDEBAR_PATHS[item] || "/premium-home/premium-members";
        navigate(path);
    };

    const handleMobilePremiumBack = () => {
        navigateBackFromConsumerFilter();
    };

    const premiumFilterNavState = { premiumSidebarActive: 'Premium Members' };

    const handleAddFilter = () => {
        setGearMenuOpen(false);
        navigate('/premium-home/member-create-filter-100', {
            state: { ...premiumFilterNavState, comingFrom: 'Create' },
        });
    };

    const handleEditFilter = (item) => {
        const userPreferenceId = item?.user_preference_id ?? '';

        navigate('/premium-home/member-create-filter-100', {
            state: {
                ...premiumFilterNavState,
                user_preference_id: userPreferenceId,
                comingFrom: 'Edit',
                itemData: item,
            },
        });
    };

    const openDeleteConfirm = (item) => {
        const selectedId = item?.user_preference_id ?? null;
        if (!selectedId) {
            showNotification('Error', 'Invalid filter id', 'danger');
            return;
        }
        setDeleteFilterId(selectedId);
        setDeleteConfirmOpen(true);
    };

    const handleConfirmDelete = () => {
        if (!deleteFilterId) return;
        deleteFilterApi(deleteFilterId);
        setDeleteConfirmOpen(false);
        setDeleteFilterId(null);
    };

    const closeDeleteConfirm = () => {
        setDeleteConfirmOpen(false);
        setDeleteFilterId(null);
    };


    function fetchFilterApi(userid) {
        console.log('userID : ' + userid)
        let formdata = new FormData();
        formdata.append("key", "81dc9bdb52d04dc20036dbd8313ed055")
        formdata.append("user_id", userid);
        // formdata.append("filter_type", 'pool');     //c81e728d9d4c2f636f067f89cc14862c
        fetch(baseURL.URL + '/consumer_portfolio/fetch_consumer_filters', { method: 'POST', body: formdata })
            .then((response) => response.json())
            .then((responseJson) => {
                console.log('***********###########*************');
                console.log(responseJson?.response?.user_pref);
                const raw = responseJson?.response?.user_pref;
                const nextList = Array.isArray(raw) ? raw : [];
                setFilterList(nextList);
                setLoadData(true);
            })
            .catch((error) => {
                console.error(error);
                showNotification('Error', 'Failed to fetch filters', 'danger');
                setFilterList([]);
                setLoadData(true);
            });
    }

    function deleteFilterApi(userPrefId) {
        console.log(userPrefId);
        let formdata = new FormData();
        formdata.append("key", "81dc9bdb52d04dc20036dbd8313ed055")
        formdata.append("user_id", userID);
        formdata.append("user_pref_id", userPrefId);
        fetch(baseURL.URL + '/member/delete_hundredp_filter', { method: 'POST', body: formdata })
            .then((response) => response.json())
            .then((responseJson) => {
                console.log(responseJson.response);
                if (responseJson?.server?.result_code === 200) {
                    fetchFilterApi(userID);
                    showNotification('Success', responseJson.server.message || 'Filter deleted successfully', 'success');
                } else {
                    showNotification('Error', responseJson?.server?.message || 'Failed to delete filter', 'danger');
                }
            })
            .catch((error) => {
                console.error(error);
                showNotification('Error', 'Failed to delete filter', 'danger');
            });
    }

    function toggleChangeAPI(userPrf, status) {
        console.log(userID)
        console.log(userPrf)
        console.log(status)
        let formdata = new FormData();
        formdata.append("key", "81dc9bdb52d04dc20036dbd8313ed055")
        formdata.append("user_id", userID);
        formdata.append("user_pref_id", userPrf);
        formdata.append("status", status);
        fetch(baseURL.URL + '/member/hundredp_filter_toggle', { method: 'POST', body: formdata })
            .then((response) => response.json())
            .then((responseJson) => {
                console.log(responseJson.response);
                if (responseJson?.server?.result_code === 200) {
                    // setLoadData(false);
                    fetchFilterApi(userID);
                    showNotification('Success', responseJson?.server?.message || 'Filter toggled successfully', 'success');
                } else {
                    setActiveMap((prev) => ({ ...prev, [userPrf]: !isStatusOn(status) }));
                    showNotification('Error', responseJson?.server?.message || 'Failed to toggle filter', 'danger');
                }
            })
            .catch((error) => {
                console.error(error);
                setActiveMap((prev) => ({ ...prev, [userPrf]: !isStatusOn(status) }));
                showNotification('Error', 'Failed to toggle filter', 'danger');
            });
    }

    const pageBody = !loadData ? (
        <div className="content-right member-filter-page page-loader-wrapper">
            <div className="react-js-loader">
                <div className="react-js-loader-spinner"></div>
                <p className="react-js-loader-text">Loading...</p>
            </div>
        </div>
    ) : (
        <div className="content-right member-filter-page">
            <div className="search-filter-section member-filter-search gap-2">
                <div className="page-back-btn flex align-items-center">
                    <button type="button" className="back-btn-icon" onClick={navigateBackFromConsumerFilter}>
                        <i className="fa-solid fa-arrow-left"></i>
                    </button>
                </div>
                <div className="search-bar">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" className="search-icon">
                        <path d="M9.16667 15.8333C12.8486 15.8333 15.8333 12.8486 15.8333 9.16667C15.8333 5.48477 12.8486 2.5 9.16667 2.5C5.48477 2.5 2.5 5.48477 2.5 9.16667C2.5 12.8486 5.48477 15.8333 9.16667 15.8333Z" stroke="#c6c6c6" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M17.5 17.5L13.875 13.875" stroke="#c6c6c6" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                    <input
                        type="text"
                        placeholder="Quick Search"
                        className="search-input"
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                    />
                </div>
            </div>

            <div className="member-filter-grid">
                {filteredCards.map((item) => (
                    <div key={item.user_preference_id} className="member-filter-card">
                        <span className="member-filter-badge">{item.member_count}</span>

                        <div className="member-filter-card-header">
                            <div>
                                <p className="member-filter-label">{stringsoflanguages.country}</p>
                                <h4 className="member-filter-country">{item.country_name}</h4>
                            </div>
                            <button
                                type="button"
                                className={`member-filter-switch ${(activeMap[item.user_preference_id] ?? isStatusOn(item?.status ?? item?.toggle_status ?? item?.filter_status ?? item?.active_status)) ? 'active' : ''}`}
                                onClick={() => handleToggleClick(item)}
                                aria-label="Toggle filter"
                            >
                                <span />
                            </button>
                        </div>

                        <div className="member-filter-card-body">
                            <div className="member-filter-row">
                                <p className="member-filter-label">{stringsoflanguages.state}</p>
                                <p className="member-filter-value">{item.states || '—'}</p>
                            </div>
                            <div className="member-filter-row">
                                <p className="member-filter-label">{stringsoflanguages.city}</p>
                                <p className="member-filter-value">{item.cities || '—'}</p>
                            </div>
                        </div>

                        <div className="member-filter-card-footer">
                            <button type="button" className="member-filter-edit-btn" onClick={() => handleEditFilter(item)}>
                                {stringsoflanguages.edit} <i className="fa-regular fa-pen-to-square" />
                            </button>
                            <button type="button" className="member-filter-delete-btn" onClick={() => openDeleteConfirm(item)}>
                                {stringsoflanguages.delete} <i className="fa-regular fa-trash-can" />
                            </button>
                        </div>
                    </div>
                ))}
            </div>

            {/* {!isMobile && (
                <div className="btn-section btn-section-gear" ref={gearMenuRef}>
                    <button
                        type="button"
                        className={`btn-primary gear-btn ${gearSpinning ? 'gear-spin' : ''}`}
                        onClick={() => {
                            setGearMenuOpen((prev) => !prev);
                            setGearSpinning(true);
                            setTimeout(() => setGearSpinning(false), 500);
                        }}
                        aria-label="Options"
                        aria-expanded={gearMenuOpen}
                    >
                        <i className="fa-solid fa-gear" />
                    </button>
                    {gearMenuOpen && (
                        <ul className="gear-dropdown" aria-label="Options list">
                            <li>
                                <button type="button" className="gear-dropdown-item" onClick={() => handleAddFilter()}>
                                    <i className="fa-solid fa-plus" />
                                    <span>{stringsoflanguages.addFilter}</span>
                                </button>
                            </li>
                        </ul>
                    )}
                </div>
            )}

            {isMobile && (
                <>
                    <nav className="mobile-bottom-nav liquidGlass-wrapper dock member-filter-footernav" aria-label="Filter actions">
                        <div className="liquidGlass-effect" aria-hidden="true" />
                        <div className="liquidGlass-shine" aria-hidden="true" />
                        <div className="mobile-nav-item cursor-pointer" aria-label="Add Filter" role="button" tabIndex={0} onClick={() => handleAddFilter()}>
                            <i className="fa-solid fa-plus" />
                        </div>
                    </nav>
                    <svg style={{ display: 'none' }} aria-hidden="true">
                        <filter id="glass-distortion-member-filter" x="0%" y="0%" width="100%" height="100%" filterUnits="objectBoundingBox">
                            <feTurbulence type="fractalNoise" baseFrequency="0.01 0.01" numOctaves="1" seed="5" result="turbulence" />
                            <feComponentTransfer in="turbulence" result="mapped">
                                <feFuncR type="gamma" amplitude="1" exponent="10" offset="0.5" />
                                <feFuncG type="gamma" amplitude="0" exponent="1" offset="0" />
                                <feFuncB type="gamma" amplitude="0" exponent="1" offset="0.5" />
                            </feComponentTransfer>
                            <feGaussianBlur in="turbulence" stdDeviation="3" result="softMap" />
                            <feSpecularLighting in="softMap" surfaceScale="5" specularConstant="1" specularExponent="100" lightingColor="white" result="specLight">
                                <fePointLight x="-200" y="-200" z="300" />
                            </feSpecularLighting>
                            <feComposite in="specLight" operator="arithmetic" k1="0" k2="1" k3="1" k4="0" result="litImage" />
                            <feDisplacementMap in="SourceGraphic" in2="softMap" scale="150" xChannelSelector="R" yChannelSelector="G" />
                        </filter>
                    </svg>
                </>
            )} */}

            {deleteConfirmOpen && (
                <div className="modal-overlay" role="dialog" aria-modal="true" aria-label="Delete filter confirmation">
                    <div className="logout-modal">
                        <h2 className='text-white mb-2'>{stringsoflanguages.deleteFilter}?</h2>
                        <p className='text-white mb-4'>{stringsoflanguages.doYouWantToDeleteThisFilter}?</p>
                        <div className="btn-sec">
                            <button type="button" className="save-btn" onClick={handleConfirmDelete}>{stringsoflanguages.yes}</button>
                            <button type="button" className="cancel-btn" onClick={closeDeleteConfirm}>{stringsoflanguages.no}</button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );

    return (
        <section className="home">
            <div className="container">
                <div className="content-holder">
                    <PremiumSidebar activeItem={activeItem} setActiveItem={handlePremiumSidebarNavigate} />
                    <div className={`content-right-wrapper ${isMobilePageOpen ? 'mobile-page-open' : ''}`}>
                        {isMobile && isMobilePageOpen && (
                            <div className="mobile-page-header">
                                <button type="button" className="mobile-back-btn" onClick={handleMobilePremiumBack}>
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                    >
                                        <path
                                            d="M15 18L9 12L15 6"
                                            stroke="white"
                                            strokeWidth="2"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                    </svg>
                                    Back
                                </button>
                                <h2 className="mobile-page-title">{stringsoflanguages.filter}</h2>
                            </div>
                        )}
                        {pageBody}
                    </div>
                </div>
            </div>
        </section>
    );
}
